import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

/**
 * Components
 */
import { ChangesNotSaved } from './components/changes-not-saved/changes-not-saved.component';
import { SubmitLtiTest } from './components/submit-lti-test/submit-lti-test.component'
import { AttemptsExceeded } from './components/attempts-exceeded/attempts-exceeded.component'

// Components required for launch of activity
import { ProductView } from './components/product-view/product-view.component';
import { LORenderer } from './components/lo-renderer/lo-renderer.component';
import { ActivityLaunch } from './components/activity-launch/activity-launch.component';
import { LearningPath } from './components/learning-path/learning-path.component';
import { TextEditor } from './components/text-editor/text-editor.component';
import { ProductiveSkill } from './components/productive-skill/productive-skill.component';
import { Recording } from './components/recording/recording.component';
import { SaveAlert } from './components/save-alert/save-alert.component';
import { SubmittedSpeakingPSkill } from './components/submitted-speaking-pSkill/submitted-speaking-pSkill.component';
import { MessageBanner } from './components/message-banner/message-banner.component';
/**
 * Modules
 */
import { SharedAllModule } from '../shared-all/shared-all.module';

/**
 * Services
 */
import { CustomTranslationLoader } from '../app/services/custom-translation-loader';
import { PushXService } from './services/pushx.service';
import { RecordingHelperService } from './services/recording-helper.service';
import { TrackUserService } from './services/track-user-service';

// Services required for launch of activity
import { ProductViewDataService } from './services/product-view-data.service';
import { ProductViewResolverService } from './services/product-view-resolver.service';
import { TeacherProductViewResolverService } from './services/teacher-product-view-resolver.service';
import { ProductViewHelperService } from './services/product-view-helper.service';
import { SaveWarningGuard } from './services/save-warning-guard.service';
import { CanDeactivateLPGuard } from './services/can-deactivate-lp-guard.service';
import { FloatToIntPipe } from './pipes/floatToInt.pipe';
import { ElapsedTimePipe } from './pipes/elapsedTime.pipe';
import { WordCountPipe } from './pipes/wordCount.pipe';
import { ActivityQuestion } from './components/activity-question/activity-question.component';
import { CollaborativeSkill } from './components/collaborative-skill/collaborative-skill.component';
import { GetStreamCommentsService } from './services/getstream-comments.service';
import { GroupHelperService } from './services/groups-helper.service';
import { ResultScreen } from './components/result-screen/result-screen.component';
import { ProductTocService } from './services/product-toc.service';
import { LTILaunchService } from './services/lti-launch.service'
import { GenericLti } from './components/generic-lti/generic-lti.component';
import { UserAttemptHelper } from './services/user-attempt-helper.service';
import { AudioPlayerService } from './services/audio-player.service';
import { LtiResultScreen } from './components/lti-result-screen/lti-result-screen.component';
import { TestHelperService } from './services/test-helper.service';
import { LitmusServiceUnavailable } from './components/litmus-service-unavailable-modal/litmus-service-unavailable-modal.component';
import { LitmusServiceUnavailableScreen } from './components/litmus-service-unavailable-screen/litmus-service-unavailable-screen.component';
import { UserSettingsService } from './services/user-settings.service';
import { ContentAccessHelperService } from './services/content-access-helper.service';
import { EventService } from './services/event.service';
import { ProductViewV4 } from './components/product-view-v4/product-view-v4.component';
import { A11yModule } from '@angular/cdk/a11y';

//Directives
import { ImageThumbnailUpdate } from './directives/image-thumbnail-update';

@NgModule({
  declarations: [
    ChangesNotSaved,
    ProductView,
    LORenderer,
    LearningPath,
    ActivityLaunch,
    ActivityQuestion,
    CollaborativeSkill,
    TextEditor,
    ProductiveSkill,
    Recording,
    SaveAlert,
    FloatToIntPipe,
    ElapsedTimePipe,
    WordCountPipe,
    SubmittedSpeakingPSkill,
    ResultScreen,
    GenericLti,
    SubmitLtiTest,
    MessageBanner,
    AttemptsExceeded,
    LtiResultScreen,
    LitmusServiceUnavailable,
    LitmusServiceUnavailableScreen,
    ImageThumbnailUpdate,
    ProductViewV4
  ],
  imports: [
    TranslateModule.forChild({
      loader: { 
        provide: TranslateLoader, 
        useClass: CustomTranslationLoader 
      }
    }),
    CommonModule,
    RouterModule,
    FormsModule,
    SharedAllModule,
    A11yModule
  ],
  providers: [
    ProductViewDataService,
    ProductViewResolverService,
    TeacherProductViewResolverService,
    ProductViewHelperService,
    SaveWarningGuard,
    CanDeactivateLPGuard,
    GetStreamCommentsService,
    GroupHelperService,
    PushXService,
    RecordingHelperService,
    ElapsedTimePipe,
    WordCountPipe,
    ProductTocService,
    LTILaunchService,
    UserAttemptHelper,
    AudioPlayerService,
    TestHelperService,
    UserSettingsService,
    TrackUserService,
    EventService,
    ContentAccessHelperService
  ],
  exports : [
    ProductView,
    ActivityLaunch,
    ResultScreen,
    MessageBanner,
    ImageThumbnailUpdate,
    ProductViewV4
  ]
})
export class SharedPostLoginModule {
  
}
